import PropTypes from 'prop-types';

export const GroupRendererPropTypes = {
  ibtAmount: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  tagName: PropTypes.string.isRequired,
  account: PropTypes.string,
  isLastInBranch: PropTypes.bool,
};

export const CttGroupRendererPropTypes = {
  rowData: PropTypes.shape({
    amount: PropTypes.number.isRequired,
    countryTaxTypeDescription: PropTypes.string.isRequired,
    columnsData: PropTypes.arrayOf(PropTypes.number).isRequired,
  }).isRequired,
  ibtAmount: PropTypes.number.isRequired,
  tagName: PropTypes.string.isRequired,
  account: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  hasRightsToModifyCTT: PropTypes.bool.isRequired,
};
